import { ApplicationCardDto } from '~/modules/Products/Application/Dtos/ApplicationCardDto'
import { ComponentCardDto } from '~/modules/Products/Infrastructure/Dtos/ComponentCardDto'

export class ComponentCardDtoTransformer {
  public static fromApplication (applicationCardDto: ApplicationCardDto): ComponentCardDto {
    return {
      id: applicationCardDto.id,
      organizer: {
        name: applicationCardDto.organizer.name,
        color: applicationCardDto.organizer.color,
      },
      type: applicationCardDto.type,
      content: {
        header: applicationCardDto.content.header,
        subtitle: applicationCardDto.content.subtitle,
        title: applicationCardDto.content.title,
      },
      description: applicationCardDto.description,
      mintStatus: applicationCardDto.mintStatus,
      imageUrl: applicationCardDto.imageUrl,
    }
  }
}
